"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixBucketName = void 0;
const fixBucketName = (awsbucket, awsregion) => {
    const environment = process.env.ENVIRONMENT;
    if (environment === 'stage') {
        return `ga-${environment}${process.env.S3_POST_FIX}-${awsregion}`;
    }
    return awsbucket;
};
exports.fixBucketName = fixBucketName;
